export default __webpack_public_path__ + "static/media/pdf_white.8688086d.png";